import { z } from 'zod';
import { addressNameSchema, addressPartSchemas, addressSchema, nameSchema, } from './create-input.js';
import { refineBillingRequiredWhenDistinct } from './refine-billing-required-when-distinct.js';
/** Shared shape for a single billing/shipping location within a pair-create input. */
export function buildAddressLocationInputSchema(strictness = {}) {
    return z.object({
        addressName: addressNameSchema,
        address: addressSchema,
        ...addressPartSchemas(strictness),
    });
}
/** Loose by default -- vendor pair-create shares this shape and keeps the looser rule. */
export const addressLocationInputSchema = buildAddressLocationInputSchema();
function addressPairLocationFields(strictness) {
    const location = buildAddressLocationInputSchema(strictness);
    return {
        shipping: location,
        billingSameAsShipping: z.boolean(),
        billing: location.nullish(),
    };
}
/** The pair's two locations alone, for a caller that supplies the owner's name itself (New Customer). */
export function buildAddressPairLocationsInputSchema(strictness = {}) {
    return z
        .object(addressPairLocationFields(strictness))
        .superRefine(refineBillingRequiredWhenDistinct);
}
/**
 * Billing/shipping pair-create input without `defaultFlag`.
 * Customer pair-create always writes shipping as default (R4) — callers must not send defaultFlag.
 */
export function buildBillingAndShippingAddressesInputSchema(strictness = {}) {
    return z
        .object({ name: nameSchema, ...addressPairLocationFields(strictness) })
        .superRefine(refineBillingRequiredWhenDistinct);
}
export const billingAndShippingAddressesInputSchema = buildBillingAndShippingAddressesInputSchema();
//# sourceMappingURL=create-pair-input.js.map